import { Add } from "@mui/icons-material";
import { Button, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import {
  GetApiUploadedFilesApiResponse,
  useGetApiUploadedFilesQuery,
} from "src/app/services/api.generated";
import { UploadedFilesData } from "src/components/entities/uploadedFiles/tables/uploadedFilesData";
import TableSkeletonRow from "src/components/molecule/TableSkeletonRow";
import DataTable from "src/components/organization/DataTable";
import BreadCrumbs from "src/components/organization/layout/breadcrumbs/BreadCrumbs";

function UploadedFiles() {
  const { data, isLoading, refetch } = useGetApiUploadedFilesQuery();
  const [enhancedData, setEnhancedData] = useState<
    GetApiUploadedFilesApiResponse[]
  >([]);
  const navigate = useNavigate();
  useEffect(() => {
    if (data) {
      setEnhancedData(
        data.slice().reverse().map((x) => {
          return {
            ...x,
            file_metadata: JSON.parse(x.file_metadata).filename.length > 30 ? JSON.parse(x.file_metadata).filename.substring(0, 20) : JSON.parse(x.file_metadata).filename,
            file_status: x.file_status === 1 ? "ناتمام" : "تکمیل شده",
            file_size: `${Math.floor(+x.file_size / (1024 * 1024))} مگابایت`,
          } as GetApiUploadedFilesApiResponse;
        })
      );
    }
  }, [data]);

  if (isLoading) {
    return <TableSkeletonRow title="فایل های آپلود شده" cellCount={4} />;
  } else {
    return (
      <>
        <Stack
          sx={{ width: "100%" }}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <BreadCrumbs spaceBottom={false} />
          <Button
            startIcon={<Add />}
            variant="contained"
            onClick={() => navigate("/files/upload-file")}
          >
            آپلود فایل جدید
          </Button>
        </Stack>
        <br />
        <DataTable
          rows={enhancedData}
          columns={UploadedFilesData}
          title={"فایل های آپلود شده"}
          pathname={"/files/uploaded-files"}
        />
      </>
    );
  }
}

export default UploadedFiles;
